import { $t } from "@/i18n";

const MATCHED_CLIENT_STATUS = {
    ADD_NEW_UNMATCHED: 'add_new_unmatched',
    ADD_NEW_MATCHED: 'add_new_matched',
    IGNORE: 'ignore'
}

const getMatchedClientStatus = (selectedImportClients, importClientId) => {
    const foundClient = selectedImportClients.find(x => x.import_client_id === importClientId)
    if (foundClient) {
        if (foundClient.uku_client_id) {
            return MATCHED_CLIENT_STATUS.ADD_NEW_MATCHED
        } else {
            return MATCHED_CLIENT_STATUS.ADD_NEW_UNMATCHED
        }
    }

    return MATCHED_CLIENT_STATUS.IGNORE
}

const getMatchedClientAction = (selectedImportClients, importClientId) => {
    const foundClient = selectedImportClients.find(x => x.import_client_id === importClientId)
    if (foundClient) {
        if (foundClient.uku_client_id) {
            return $t('Update')
        } else {
            return $t('Add')
        }
    }

    return $t('Ignore')
}

const showCompanyRegister = (importType) => {
    // for now all import types should show the toggle
    return true
}

export default {
    getMatchedClientStatus,
    MATCHED_CLIENT_STATUS,
    showCompanyRegister,
    getMatchedClientAction
}